import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./login.css";
import { BASE_URL, LOGIN } from "../../services/api.config";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setProfileSlice } from "../../redux/slices/profile_slice";
import { toast } from "react-toastify";

export const Login = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [loginType, setLoginType] = useState("Personal");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const { profileDataRedux } = useSelector((state) => state?.profile);
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
    // .min(8, "Password must be at least 8 characters")
    // .max(30, "Password must be at most 30 characters")
    // .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    // .matches(/[0-9]/, "Password must contain at least one number")
    // .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    // .matches(
    //   /[!@#$%^&*(),.?":{}|<>]/,
    //   "Password must contain at least one special character"
    // )
  });

  const fetchUserDetails = async (user_id) => {
    if (user_id) {
      try {
        const response = await Axios.get(`/users/${user_id}`);
        const data = response?.data?.data?.user;
        dispatch(setProfileSlice(data));
      } catch (error) {
        console.log("error response:", error);
      }
    }
  };

  const handleSubmit = (values) => {
    setLoader(true);
    Axios.post(`${BASE_URL}/${LOGIN}`, { ...values, account_type: loginType })
      .then((res) => {
        let data = res.data.data;
        localStorage.setItem("user", JSON.stringify(data));
        fetchUserDetails(data?.user_id);
        toast.success(res?.data?.message);
        navigate("/dashboard");
        console.log("login:", res);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          const messages = err?.response?.data?.message;

          if (Array.isArray(messages)) {
            // If multiple errors, loop through and show them
            messages.forEach((error) => {
              toast.error(error);
            });
          } else {
            // If it's a single error message, show it directly
            toast.error(messages);
          }
          setLoader(false);
          console.log("login Error:", err);
        }
        if (err?.response?.status === 401) {
          const message = err?.response?.data?.data?.message;
          if (Array.isArray(message)) {
            message.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error(message);
          }
          setLoader(false);
          console.log("login Error401:", err);
        }
      });
  };

  return (
    <div className="authentication-wrapper authentication-cover authentication-bg">
      <div className="authentication-inner row">
        <div className="d-none d-lg-flex col-lg-7 p-0">
          {/* <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center"> */}
          <img
            src="../../assets/img/img-signup.png"
            alt="auth-login-cover"
            className="img-fluid my-0 auth-illustration positioned-image"
            style={{ maxHeight: "900px", height: "900px", width: "1050px" }}
          />
        </div>
        <div className="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
          <div className="w-px-400 mx-auto">
            <div className="app-brand mb-2">
              <Link to="index.html" className="app-brand-link ">
                <span className="app-brand-logo demo">
                  <img
                    src="../../assets/img/flowersvg.svg"
                    style={{
                      width: "40px",
                      height: "26px",
                      // borderRadius: "50%",
                    }}
                  />
                </span>
              </Link>
            </div>
            <h3 className="mb-1">Welcome to Zenosure!</h3>
            <p className="mb-4">
              Please sign-in to your account and start your savings now!!
            </p>

            <Formik
              initialValues={{ email: "", password: "" }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {({ errors, touched, resetForm }) => (
                <Form>
                  <ul className=" nav nav-pills d-flex mb-4">
                    <li className="nav-item col-4">
                      <button
                        type="button"
                        className={`nav-link ${loginType === "Personal" && "active"
                          }`}
                        onClick={() => {
                          setLoginType("Personal");
                          resetForm();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Personal
                      </button>
                    </li>

                    <li className="nav-item mx-2 col-4">
                      <button
                        type="button"
                        className={`nav-link ${loginType === "Corporate" && "active"
                          }`}
                        onClick={() => {
                          setLoginType("Corporate");
                          resetForm();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Corporate
                      </button>
                    </li>
                  </ul>
                  <div className="mb-3">
                    <label for="email" className="form-label">
                      Email
                    </label>
                    <Field
                      type="email"
                      className={`form-control ${errors.email ? "invalid-form-input" : ""
                        }`}
                      name="email"
                      placeholder="Enter your email or username"
                      autofocus
                    />

                    <ErrorMessage
                      name="email"
                      component="div"
                      className="invalid-form"
                    />
                  </div>

                  <div className="mb-3 form-password-toggle">
                    <div className="d-flex justify-content-between">
                      <label className="form-label" for="password">
                        Password
                      </label>
                      <Link to="/resetPassword">
                        <small>Forgot Password?</small>
                      </Link>
                    </div>
                    <div className="input-group input-group-merge ">
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className={`form-control ${touched.email && errors.email
                            ? "invalid-form-input"
                            : ""
                          }`}
                        placeholder="••••••••••••"
                        aria-describedby="password"
                      />
                      <span
                        className="input-group-text"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                        />
                      </span>
                    </div>

                    <ErrorMessage
                      name="password"
                      component="div"
                      className="invalid-form"
                    />
                  </div>
                  <div className="mb-3">
                    <div className="form-check">
                      <Field
                        className="form-check-input"
                        type="checkbox"
                        id="remember-me"
                        name="rememberMe"
                      />
                      <label className="form-check-label" for="remember-me">
                        Remember Me
                      </label>
                    </div>
                  </div>
                  {loader ? (
                    <div className="text-center">
                      <div class="spinner-border text-primary " role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button
                      className="btn btn-primary d-grid w-100"
                      type="submit"
                    >
                      Sign in
                    </button>
                  )}
                </Form>
              )}
            </Formik>

            <p className="text-center mt-3">
              <span className="me-2">Are you new to our platform?</span>
              <Link to="/register">
                <span>Create an account</span>
              </Link>
            </p>
            {/* 
            <div className="divider my-4">
              <div className="divider-text">or</div>
            </div>

            <div className="d-flex justify-content-center">
              <Link
                to="javascript:;"
                className="btn btn-icon btn-label-facebook me-3"
              >
                <i className="tf-icons fa-brands fa-facebook-f fs-5"></i>
              </Link>

              <Link
                to="javascript:;"
                className="btn btn-icon btn-label-google-plus me-3"
              >
                <i className="tf-icons fa-brands fa-google fs-5"></i>
              </Link>

              <Link to="javascript:;" className="btn btn-icon btn-label-twitter">
                <i className="tf-icons fa-brands fa-twitter fs-5"></i>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
